export function useTooltip() {
  const tooltipFormatter = (data) => {
    const property = data?.column?.property;
    if (property && property === 'platform_name') {
      const cellValue = data.cellValue;
      if (cellValue && cellValue.length >= 1) {
        return data.cellValue[0].text;
      } else {
        return null;
      }
    }

    return null;
  }; 
  
  return { tooltipFormatter };
}